import { FormFieldProps, NullableFormValue, ValueManager } from "../index";
import { getHolder } from "../Utils";


class DefaultValueManager<X, XT> implements ValueManager<X, XT> {
	read( props: FormFieldProps<X, XT>, key: string ) {
		const holder = getHolder( props );
		return holder.readValue( key );
	}

	write( props: FormFieldProps<X, XT>, key: string, value: NullableFormValue<X, XT>, callback?: () => void ) {
		const holder = getHolder( props );
		return holder.writeValue( key, value, callback );
	}

}

export const defaultValueManager = new DefaultValueManager<any, any>();
